module.exports = __webpack_public_path__ + "themes/fq/font/SignPainter-HouseScript.ttf";


//////////////////
// WEBPACK FOOTER
// ./themes/fq/font/SignPainter-HouseScript.ttf
// module id = 88
// module chunks = d-game